// extracted by mini-css-extract-plugin
export default {"noContentMessage":"MissingInvoicesTable_noContentMessage__IP15p"};